import { PDFDownloadLink } from '@react-pdf/renderer';
import React, { useEffect, useState } from 'react';
import BudgetDocument from '../BudgetDocument/BudgetDocument';
import { getAccessTokenApi } from 'api/auth';
import { getImagesApi, getItemsApi, getStaticBudgetData } from 'api/budget';
import { Button } from 'antd';
import useTemplateOrFallback from 'PDF/TemplateEngine/useTemplateOrFallback';
import { useTenantColors } from 'hooks/useTenantColors';

// Pipeline V2 LEGACY — preservado para budgets creados con `version=2.0`.
// Los budgets nuevos nacen con `version=3.0` y van por `PresupuestoV3/` que
// usa TemplateRenderer end-to-end. Este componente mantiene el look V2
// hardcoded (Portrait/Header/Footer/Body) + inyección parcial del template
// solo para la sección de items via RenderTemplateBody (migración previa).
function BudgetDowload(props) {
  const { budget } = props;
  const token = getAccessTokenApi();
  const [items, setItems] = useState([]);
  const [images, setImages] = useState([]);
  const [config, setConfig] = useState({});
  const [staticData, setStaticData] = useState([]);

  // Banderas de carga por fetch. NO alcanza con mirar el contenido: una lista
  // vacia es un valor final legitimo, asi que hay que registrar aparte si la
  // respuesta ya llego.
  const [itemsReady, setItemsReady] = useState(false);
  const [imagesReady, setImagesReady] = useState(false);
  const [staticReady, setStaticReady] = useState(false);

  const { template, loading: templateLoading } = useTemplateOrFallback('presupuesto');
  const tenantColors = useTenantColors();

  useEffect(() => {
    let cancelled = false;
    setItemsReady(false);
    getItemsApi(token, budget.idBudget)
      .then((result) => {
        if (!cancelled) setItems(result.items);
      })
      // `finally` y no `then`: si el fetch falla, el boton se habilita igual en
      // vez de quedar colgado para siempre.
      .catch((err) => {
        // Sin este catch la cadena termina en un unhandled rejection cuando el
        // fetch falla. El documento se arma sin este dato, pero el boton se
        // habilita igual (ver el `finally`) para no dejarlo colgado.
        console.error('[PDF] No se pudo cargar un dato del documento:', err);
      })
      .finally(() => {
        if (!cancelled) setItemsReady(true);
      });
    return () => {
      cancelled = true;
    };
  }, [token, budget?.idBudget]);
  useEffect(() => {
    let cancelled = false;
    setStaticReady(false);
    getStaticBudgetData(token)
      .then((result) => {
        if (cancelled) return;
        setConfig(result.tenant);
        setStaticData(result.static);
      })
      .catch((err) => {
        // Sin este catch la cadena termina en un unhandled rejection cuando el
        // fetch falla. El documento se arma sin este dato, pero el boton se
        // habilita igual (ver el `finally`) para no dejarlo colgado.
        console.error('[PDF] No se pudo cargar un dato del documento:', err);
      })
      .finally(() => {
        if (!cancelled) setStaticReady(true);
      });
    return () => {
      cancelled = true;
    };
  }, [token]);
  useEffect(() => {
    let cancelled = false;
    setImagesReady(false);
    getImagesApi(token, budget?.idBudget)
      .then((result) => {
        if (!cancelled) setImages(result.images);
      })
      .catch((err) => {
        // Sin este catch la cadena termina en un unhandled rejection cuando el
        // fetch falla. El documento se arma sin este dato, pero el boton se
        // habilita igual (ver el `finally`) para no dejarlo colgado.
        console.error('[PDF] No se pudo cargar un dato del documento:', err);
      })
      .finally(() => {
        if (!cancelled) setImagesReady(true);
      });
    return () => {
      cancelled = true;
    };
  }, [token, budget?.idBudget]);

  const ready = itemsReady && imagesReady && staticReady && !templateLoading;

  // El `loading` de PDFDownloadLink solo dice si termino de ARMAR el PDF, no si
  // los datos llegaron. Con los fetches en vuelo el documento se arma vacio, se
  // genera rapidisimo y el boton queda habilitado: quien haga clic en esa
  // ventana se lleva un PDF sin los datos del tenant. Por eso el link no se
  // monta hasta tener todo.
  if (!ready) {
    return (
      <Button type="primary" disabled block>
        Cargando datos...
      </Button>
    );
  }

  return (
    <PDFDownloadLink
      document={
        <BudgetDocument
          budget={budget}
          items={items}
          images={images}
          config={config}
          staticData={staticData}
          template={template}
          templateColors={tenantColors}
        />
      }
      fileName={`NDR-${budget.idBudget}.pdf`}
    >
      {({ loading }) => (
        <Button type="primary" disabled={loading} block>
          {loading ? 'Generando documento...' : 'Descargar PDF'}
        </Button>
      )}
    </PDFDownloadLink>
  );
}
export default BudgetDowload;
